// src/components/clientes/clientes.js

import React, { Fragment, useState, useEffect } from 'react';
import Breadcrumb from '../common/breadcrumb';
import Tablereact from '../common/tabulator/tablereact';
import Loader from '../common/loaderapp';
import Button from 'react-bootstrap-button-loader';

import AgregarCliente from './AgregarCliente';
import ActualizarCliente from './ActualizarCliente';

const Clientes = () => {

    const [pag_agregar, setPag_agregar] = useState(false);
    const [pag_actualizar, setPag_actualizar] = useState(0);
    const [load, setLoad] = useState(false);
    const [datos, setDatos] = useState([]); 

    const cargarClientes = () => {
        setLoad(false);
        fetch('/clientes_sitio')
            .then(res => res.json())
            .then(res => {
                setDatos(Array.isArray(res) ? res : []);
                setLoad(true);
            })
            .catch(error => {
                console.error('Error al cargar clientes:', error);
                setDatos([]);
                setLoad(true);
            });
    };

    useEffect(() => {
        cargarClientes();
    }, []);

    
    const cabecera = [
        {
            Header: <b>Nombre (s)</b>,
            accessor: 'nombre',
            show: true,
            style: { textAlign: 'center' },
            headerStyle: { textAlign: 'center' }
        },
        {
            Header: <b>Apellido (s)</b>,
            accessor: 'apellido',
            show: true,
            style: { textAlign: 'center' },
            headerStyle: { textAlign: 'center' }
        },
        {
            Header: <b>Correo</b>,
            accessor: 'correo',
            show: true,
            style: { textAlign: 'center' },
            headerStyle: { textAlign: 'center' }
        },
        {
            Header: <b>Estado</b>,
            accessor: 'estado',
            show: true,
            style: { textAlign: 'center' },
            headerStyle: { textAlign: 'center' }
        }
    ];

    const agregar = () => setPag_agregar(true);
    
    const detalle_dato = (dato) => {
        setPag_actualizar(dato.id);
    };

    return (
        <Fragment>
            
            <Breadcrumb parent="Inicio" title="Clientes" />

            {load ? (

                (!pag_agregar && !pag_actualizar) ? (

                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="card">

                                <div className="d-flex flex-row-reverse" style={{ paddingRight: 38, paddingTop: 10 }}>
                                    <Button hidden className="btn btn-primary" onClick={agregar}>
                                        Agregar cliente
                                    </Button>
                                </div>

                                <div className="card-body datatable-react">
                                    <Tablereact
                                        myData={datos}
                                        cabecera={cabecera}
                                        pageSize={20}
                                        paginacion={true}
                                        buscador="Buscar cliente"
                                        detalle={detalle_dato}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>

                ) : (
                    
                    !pag_actualizar ? (
                        <AgregarCliente setPag_agregar={setPag_agregar} />
                    ) : (
                        <ActualizarCliente
                            pag_actualizar={pag_actualizar}
                            setPag_actualizar={setPag_actualizar}
                            onClienteActualizado={() => {
                                cargarClientes();
                            }}
                        />
                    )
                )

            ) : (
                <Loader />
            )}

        </Fragment>
    );
};

export default Clientes;
